@if (isSaveFailed) {
  <mat-icon>error</mat-icon>
  <span>{{ 'saveFailed' | translate }}</span>
} @else if (isSaved) {
  <mat-icon>check</mat-icon>
  <span>{{ 'changesSaved' | translate }}</span>
} @else {
  <mat-icon class="editor-autosave-spin">sync</mat-icon>
  <span>{{ 'saving' | translate }}</span>
}
